var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTwitterVector = function SvgTwitterVector(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.0004C7.5 17.0004 0.60625 13.0004 1.5975 2.00037C1.5975 2.00037 6.555 7.00037 12.5 8.00037V6.00037C12.5 3.25037 14.75 0.966619 17.5 1.00037C18.4705 1.01164 19.4175 1.30001 20.2296 1.83151C21.0417 2.36301 21.685 3.1155 22.0837 4.00037H26.5L22.5 8.00037C21.9675 16.3554 14.99 23.0004 6.5 23.0004C2.5 23.0004 1.5 21.5004 1.5 21.5004C1.5 21.5004 5.5 20.0004 7.5 17.0004Z",
    stroke: "#82828A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTwitterVector);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyOCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuNSAxNy4wMDA0QzcuNSAxNy4wMDA0IDAuNjA2MjUgMTMuMDAwNCAxLjU5NzUgMi4wMDAzN0MxLjU5NzUgMi4wMDAzNyA2LjU1NSA3LjAwMDM3IDEyLjUgOC4wMDAzN1Y2LjAwMDM3QzEyLjUgMy4yNTAzNyAxNC43NSAwLjk2NjYxOSAxNy41IDEuMDAwMzdDMTguNDcwNSAxLjAxMTY0IDE5LjQxNzUgMS4zMDAwMSAyMC4yMjk2IDEuODMxNTFDMjEuMDQxNyAyLjM2MzAxIDIxLjY4NSAzLjExNTUgMjIuMDgzNyA0LjAwMDM3SDI2LjVMMjIuNSA4LjAwMDM3QzIxLjk2NzUgMTYuMzU1NCAxNC45OSAyMy4wMDA0IDYuNSAyMy4wMDA0QzIuNSAyMy4wMDA0IDEuNSAyMS41MDA0IDEuNSAyMS41MDA0QzEuNSAyMS41MDA0IDUuNSAyMC4wMDA0IDcuNSAxNy4wMDA0WiIgc3Ryb2tlPSIjODI4MjhBIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";